import DataGrid, {
    Column,
    Item
} from 'devextreme-react/data-grid';

import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useState } from 'react';
import { getCurrentQuarterDates } from '../../../../utils/date-utils';
import QuarterSelector from '../../../../components/quarter-selector/components/QuarterSelector';
import { useAuth } from '../../../../contexts/auth';
import { CompanyTypes } from '../../../../types/enums';
import { useGetDaysToShip } from '../api/get-days-to-ship';

export default function DaysToDeliverGrid() {

    const { startDate, endDate } = getCurrentQuarterDates();
    const [dateRange, setDateRange] = useState({ startDate, endDate });

    const orders = useGetDaysToShip(dateRange.startDate, dateRange.endDate);

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    const { user } = useAuth();
    const urlFolder = user?.companyTypeId === CompanyTypes.MFR ? "manufacturer" :
        user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER ? "service-provider" : "distributor";

    return (
        <>
            <SyncDataGrid
                stateStorageKey={urlFolder + '-days-to-ship-grid'}
                className={'dx-card wide-card'}
                dataSource={orders.data}
                keyExpr={'purchaseOrderID'}
                height="68vh"
                additionalToolbarItems={[
                    <Item location='before' key='quarter-selector'>
                        <QuarterSelector numberOfQuarters={5} onSelectionChanged={(startDate, endDate) => {
                            setDateRange({ startDate, endDate });
                        }} />
                    </Item>
                ]}
            >
                <Column
                    dataField={'poNumber'}
                    caption={'Purchase Order #'}
                    dataType="string"
                    cellRender={(row: any) => {
                        return <Link to={`/${urlFolder}/purchase-order/${row.data.purchaseOrderID}?returnUrl=${returnUrl}`}>
                            {row.data.poNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'requestedDeliveryDate'}
                    caption={'Requested Delivery Date'}
                    dataType="date"
                />
                <Column
                    dataField={'deliveredDate'}
                    caption={'Delivered Date'}
                    dataType="date"
                />
                <Column
                    dataField={'validatedDeliveryDate'}
                    caption={'Validated Delivery Date'}
                    dataType="date"
                />
                <Column
                    dataField={'daysToDelivery'}
                    caption={'Days to Delivery'}
                    dataType="number"
                    calculateDisplayValue={(data) => data.daysToDelivery < 0 ? 0 : data.daysToDelivery}
                />
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />
        </>
    )
} 
